<template>
  <div>
    <div class="form_stat">
      <div class="flex">
        <input type="date" name="date_from">
        <input type="date" name="date_to">
      </div>
      <div><input type="number" step="1" value="1" min="1" name="criteria"></div>
      <div><input type="button" value="show statistics" @click="showStat"></div>
    </div>
    <div class="stat_result"></div>
  </div>
</template>
<script>
import * as Helpers from '@/assets/js/helpers.js'

export default {
  name: 'statview',
  data: function () {
    return {}
  },
  methods: {
    showStat: function () {
      const df = document.querySelector('[name=date_from]').value + ' 00:00:00'
      const dt = document.querySelector('[name=date_to]').value + ' 23:59:59'
      const cr = document.querySelector('[name=criteria]').value

      const url = this.$dbapi + '/statview'
      const e = document.querySelector('.stat_result')
      e.innerHTML = 'Processing...'

      this.$http.post(url, { data: { df: df, dt: dt, cr: cr } })
        .then(function (response) {
          const data = Helpers.parseJSON(response.data)

          if (data === null) {
            e.innerHTML = 'Request error: no data'
            return
          }

          let str = '<div>Total sites count: ' + Object.keys(data).length + '</div>'

          for (let i in data) {
            str += '<div>' +
              '<span><a href="' + i + '" target="_blank">' + i + '</a>:</span><span>' + data[i] + '</span>' +
              '</div>'
          }

          e.innerHTML = str
        })
        .catch(function (error) {
          e.innerHTML = error
        })
    }
  },
  mounted: function () {
    const pad = function (num) {
      return ('00' + num).slice(-2)
    }

    let date = new Date()
    const ed = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate())
    date = new Date()
    date.setMonth(date.getMonth() - 1)
    const sd = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate())
    document.querySelector('[name="date_from"]').value = sd
    document.querySelector('[name="date_to"]').value = ed
  }
}
</script>
<style lang="scss">
@import "../assets/style/statview.scss"
</style>
